import { render } from "./Timestamp.vue?vue&type=template&id=948f4026&scoped=true"
import script from "./Timestamp.vue?vue&type=script&lang=js"
export * from "./Timestamp.vue?vue&type=script&lang=js"

import "./Timestamp.vue?vue&type=style&index=0&id=948f4026&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-948f4026"]])

export default __exports__